/* eslint  react/no-deprecated: 0 */
import moment from 'moment';
import { Provider } from 'react-redux';
import React, { Fragment } from 'react';
import { render } from 'react-dom';
import { preloadReady } from 'react-loadable';

import debounce from 'lodash/debounce';
import './components/app.scss';
// import './facades/global-init';
import Global from './global';
import { setIsMobileLook } from './redux/app-ui/app-ui-actions';

import BuildVersion from './components/shared/build-version';
import AdditionalStickyButtons from './components/shared/additional-sticky-buttons';

import { enums } from '@888sport/uc-sportclient-lib/dist/uc-sportclient-lib.min';

const { eEventLogType, eSources } = enums;
import { eCookies } from './utils/enums';

import HtmlHelper from './utils/html-helper';
import clientLogger from './utils/logger/client-logger';
import App from './components/app';

import { login, setUserToken } from './redux/user/user-actions';
import {  mainContentId } from './utils/constants';

export function setCookie() {
  // set cookie only if it wasn't set before
  if (
    !document.cookie
      .split(';')
      .some(item => item.includes(eCookies.sportsRibbonRendered))
  ) {
    const maxAge = moment.duration(1, 'months').asSeconds();
    document.cookie = `${eCookies.sportsRibbonRendered}=false; max-age=${maxAge}`;
  }
}

export function getConfigFromServer() {
  // get config from server
  Global.config = window.config;
  delete window.config;

  window.chunkURL = `${Global.config.clientExternalUrl}/`;

  /* if (Global.config.environment == 'local' || Global.config.environment == 'dev') {
     const {whyDidYouUpdate} = require('why-did-you-update');
     whyDidYouUpdate(React)
   }*/
}

export function setClientLogger() {
  // set logger
  Global.logger = clientLogger;
}

export function getStateFromServer() {
  // get state from server
  const state = window.__STATE__;
  delete window.__STATE__;

  return state;
}

export function getKambiConfigDataFromServer(kambiToken) {
  // get kambi config from server
  const { kambiConfigData } = window;
  kambiConfigData._kc.ticket = kambiToken;
  delete window.kambiConfigData;

  return kambiConfigData;
}

function watchForHover(container) {
  var hasHoverClass = false;
  //var container = document.body;
  var lastTouchTime = 0;

  function enableHover() {
    // filter emulated events coming from touch events
    if (new Date() - lastTouchTime < 500) return;
    if (hasHoverClass) return;

    container.className += ' hasHover';
    hasHoverClass = true;
  }

  function disableHover() {
    if (!hasHoverClass) return;

    container.className = container.className.replace(' hasHover', '');
    hasHoverClass = false;
  }

  function updateLastTouchTime() {
    lastTouchTime = new Date();
  }

  document.addEventListener('touchstart', updateLastTouchTime, true);
  document.addEventListener('touchstart', disableHover, true);
  document.addEventListener('mousemove', enableHover, true);

  enableHover();
}

export function renderClientHTMLWithReact(store, kambiConfigData) {
  const generalComponentsDivId = 'sport-client-general-components';
  HtmlHelper.createDivInBody(generalComponentsDivId);
  let generalComponentElem = document.getElementById(generalComponentsDivId);

  render(
    <Provider store={store}>
      <Fragment>
        {!Global.isProduction && <AdditionalStickyButtons />}
        <BuildVersion />
      </Fragment>
    </Provider>,
    generalComponentElem
  );

  preloadReady().then(() => {
    // hydrate requested components that are render server-side
    let container = document.getElementById(mainContentId);
    if (container) {
      render(
        <Provider store={store}>
          <App kambiConfigData={kambiConfigData} store={store} />
        </Provider>,
        container
      );
      watchForHover(container);
    }
  });
}

function updateIsMobileLook(store) {
  const isMobileLook = window.innerWidth <= 1280;
  store.dispatch(setIsMobileLook(isMobileLook));
}

export function listenMobileLookChanges(store) {
  const handleWindowResize = debounce(() => {
    updateIsMobileLook(store);
  }, 100);

  window.addEventListener('resize', handleWindowResize);
  handleWindowResize();
  updateIsMobileLook(store);
}

export function runInitialActions(store, tokenSportClient) {
  const { userContext } = store.getState();

  // do login if necessary
  let eventData = {
    type: eEventLogType.WrapperTokens,
    source: eSources.client
  };
  if (tokenSportClient) {
    eventData.found = true;
    store.dispatch(setUserToken(tokenSportClient));
    store.dispatch(login(userContext, tokenSportClient));
  } else {
    eventData.found = false;
  }
}
